const LOCAL_ITEM_BANNER_CLOSED = 'bannerClosed';

export const setBannerHash = async banner => {
    try {
        localStorage.setItem(LOCAL_ITEM_BANNER_CLOSED, banner);
        return true;
    } catch (err) {
        return null;
    }
};

export const removeBannerHash = () => {
    try {
        return localStorage.removeItem(LOCAL_ITEM_BANNER_CLOSED);
    } catch (err) {
        return null;
    }
};

export const loadBannerHash = () => {
    try {
        return localStorage.getItem(LOCAL_ITEM_BANNER_CLOSED);
    } catch (err) {
        return null;
    }
};
